const ampRegex = /&/g;
const gtRegex = />/g;
const ltRegex = /</g;
const quoteRegex = /"/g;

export const htmlEncode = (text: string) => {
  if (text === undefined || text === null) {
    return '';
  }

  return String(text)
    .replace(ampRegex, '&amp;')
    .replace(gtRegex, '&gt;')
    .replace(ltRegex, '&lt;')
    .replace(quoteRegex, '&quot;');
};

export const htmlDecode = (text: string) => {
  if (text === undefined || text === null) {
    return '';
  }

  return String(text)
    .replaceAll('&amp;', '&')
    .replaceAll('&gt;', '>')
    .replaceAll('&lt;', '<')
    .replaceAll('&quot;', '"');
};
